/* eslint-disable */
export const ADMIN_EMAIL = 'zolaoffer@gmail.com';
export const SESSION_EXPIRE_TIME = 3* 60 * 60 * 1000;
export const DEFAULT_PAGESIZE = 10;
export const NODE_LIMIT = 50;
export const UPLOAD_SIZE_LIMIT = 3000000; // 3 MB
export const ICON_FILE = 'icon.PNG';


const AWS = require('aws-sdk/dist/aws-sdk-react-native');

const credentials = {
  apsoutheast1: new AWS.CognitoIdentityCredentials(
    {
      IdentityPoolId: 'ap-southeast-1:a79a4a3a-7b7c-4d51-a553-8395a6212c11',
    },
    { region: 'ap-southeast-1' },
  ),
  useast1: new AWS.CognitoIdentityCredentials(
    {
      IdentityPoolId: 'us-east-1:75aafe69-3c03-4e9f-a505-7842eda5b52f',
    },
    { region: 'us-east-1' },
  ),
};

export const AWS_CONFIG_ALL = {
  region: 'us-east-1',
  // cognito region should be same as S3 region
  s3: {
    region: 'ap-southeast-1',
    credentials: credentials.apsoutheast1,
  },
  dynamodb: {
    region: 'us-east-1',
    credentials: credentials.useast1,
  },
};

AWS.config.update(AWS_CONFIG_ALL);

export const AWS_KMSCLIENT_CONFIG = {
  region: 'ap-southeast-1',
  credentials: credentials.apsoutheast1,
};

export const AWS_CONFIG = {
  s3: {
    bucketName: 'emil.vn', // 'emilzola';
    staticHostUrl: 'https://emil.vn',
    imgFolder: 'img',
  },
  KMS_REGION: 'ap-southeast-1',
  KMS_KEY_ID: 'bf37d9da-8c43-47f5-a2dc-746d02065e4e',
  KMS_ARN: 'arn:aws:kms:ap-southeast-1:986404676419:key/bf37d9da-8c43-47f5-a2dc-746d02065e4e',
  KMS_STS_ARN: 'arn:aws:iam::986404676419:role/kms-client',
};

export const META_KEYS = {
  USER_TYPE: 'user_type',
  USER_ROLE: 'role_type',
  EMIRATES: 'emirates',
  PRODUCT_TYPE: 'product_type',
  SIGNATURE: 'signature',
  PRODUCT_SUB_TYPE: 'product_sub_type',
};

export const INTERNAL_ADMIN_INFO = {
  data: {
    data: {
      name: 'emil.vn',
      userId: 2,
      userType: 'INTERNAL_USER',
      token: 'emilUserTokenabc',
      firstTimeLogin: false,
      permissions: [
        '*',
        'DASHBOARD::PRODUCT::USERS_MANAGEMENT::USER_PROFILE::EMAIL_TEMPLATE::EMAIL_NOTIFICATION',
      ],
    },
  },
};

export const USER_TYPE = {
  INTERNAL_USER: 'INTERNAL_USER',
  GG_USER: 'GG_USER',
};

export const listWorkplaceInternal = [
  {
    code: 'emil',
    name: 'emil',
  },
];

export const REGEX_EMAIL =
  /^(([^\?<>()[\]\,;!#$%&*+~`'?/=|:\s@\^"]+(\.[^<>()[\]\\.,;!#$%&*+~`'?/=|:\s@\^"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;

export default AWS_CONFIG;
